async function getCalendarExceptionContextService(vm, hasLoading = true) {
    hasLoading && vm.$store.commit("app/UPDATE_FLAG_SHOW_OVERLAY", true);

    try {
        const response = await vm.$http2.get(`/api/myconfig/exception-calendar/context`);

        const { data } = response.data;

        const eventTypes =
            data?.eventTypes?.map((e) => ({
                ...e,
                text: e.name
            })) ?? [];

        const resourcesList = data?.resources ?? [];

        const durationUnits =
            data.durationUnits?.map((duration) => ({
                ...duration,
                text: duration.name
            })) ?? [];

        vm.$store.commit("calendar/UPDATE_EXCEPTION_EVENT_TYPES_TOGGLE", [...eventTypes]);
        vm.$store.commit("calendar/UPDATE_DURATION_UNITS_TOGGLE", [...durationUnits]);
        vm.$store.commit("calendar/UPDATE_CONTEXT_RESOURCES", [...resourcesList]);

        return Promise.resolve(response?.data?.data);
    } catch (error) {
        return Promise.reject(error?.response?.data);
    } finally {
        hasLoading && vm.$store.commit("app/UPDATE_FLAG_SHOW_OVERLAY", false);
    }
}

export { getCalendarExceptionContextService };
